import { render, staticRenderFns } from "./SurveyCreator.vue?vue&type=template&id=d0c24008&"
import script from "./SurveyCreator.vue?vue&type=script&lang=js&"
export * from "./SurveyCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports